
import { AbstractFileUploader, IFile, IResponse, ProcessivePromise, UploadFile } from "@core/lib/file-uploader";
import { IFileUploaderOptions } from "@core/lib/file-uploader/uploader";

export class FileUploaderService extends AbstractFileUploader {

    constructor(
        private globalUniqueIdService: any,
        private eventBus: any,
        protected jobFactory: (pendingFile: UploadFile, options: IFileUploaderOptions) => ProcessivePromise<IResponse<IFile>>,
        options?: Partial<IFileUploaderOptions>
    ) {
        super(options);
        console.log(this);
    }


    /**
    * 创建文件ID
    * @param length 数量
    */
    getFileIds(qty: number): Promise<Array<number>> {
        return this.globalUniqueIdService.getList(qty);
    }

    //SECTION - 事件通知 star

    /**
     * 上传前通知
     * @param fileLength 
     */
    protected beforeBatchUpload?(fileLength: number, group?: string): void {
        this.eventBus.dispatch("beforeBatchUpload", { fileLength: fileLength, group: group });
    }

    /**
     * 准备批次读取文件
     * @param batchId 
     * @param group 
     */
    protected beforeBatchRead(batchId: number, group?: string) {
        this.eventBus.dispatch("beforeBatchRead", { batchId: batchId, group: group });
    }

    /**
     * 准备读取单文件
     * @param item 
     */
    protected beforeItemRead(item: UploadFile) {
        this.eventBus.dispatch("beforeItemRead", item);
    }

    /**
     * 单文件读取完成
     * @param item 
     */
    protected afterItemRead(item: UploadFile, status: boolean): void {
        try {
            this.eventBus.dispatch("afterItemRead", { item: item, status: status });
        } catch (error) {
            throw error
        }
    }

    /**
     * 一批文件读取完成
     * @param batchId
     */
    protected afterBatchRead(batchId: number) {
        this.eventBus.dispatch("afterBatchRead", { batchId: batchId });
    }


    /**
     * 上传文件进度
     * @param uploadFile 
     */
    protected onItemProcessing(uploadFile: UploadFile) {
        this.eventBus.dispatch("onItemProcessing", uploadFile);
    }

    /**
     * @param source 文件数据源
     * @param fileIds 文件标识
     * @description 单个文件上传成功的回调
     */
    protected onItemSuccess(uploadFile: UploadFile): void {
        if (uploadFile)
            this.eventBus.dispatch("onItemSuccess", uploadFile);
    }

    /**
     * @param errorCode 
     * @param source 
     * @param fileIds 
     * @description 单个文件上传失败的回调
     */
    protected onItemError(uploadFile: UploadFile): void {
        this.eventBus.dispatch("onItemError", uploadFile);
    }

    protected afterItemUpload(uploadFile: UploadFile) {
        this.eventBus.dispatch("afterItemUpload", uploadFile);
    }

    /**
     * 所有上传任务结束，没有正在上传的内容
     */
    protected afterBatchUpload(batchId: number): void {
        this.eventBus.dispatch("afterBatchUpload", { batchId: batchId });
    }

    //!SECTION - 事件通知 end
}